import type {ChangeEvent} from 'react';

/*
  안드로이드 > 삼성 키보드 > 문구 추천 ON인 경우 input의 maxlength가 설정되어 있어도 해당 maxlength를 무시하고 텍스트가 입력되는 현상이 있습니다. (onBlur 또는 커서 이동시 maxlegnth 만큼으로 돌아오긴함)
  해당 케이스의 경우 input의 maxlength 속성이 무시될 수 있기 때문에 직접 제어해주도록 합니다.
*/
export const getTrimmedTextEvent = (
  e: ChangeEvent<HTMLInputElement>,
  maxLength: number
) => {
  if (e.target.value.length > maxLength) {
    e.target.value = e.target.value.slice(0, maxLength);
  }
  return e;
};
